import { __require as t } from "./main67.js";
var r, e;
function u() {
  if (e) return r;
  e = 1;
  var a = t();
  function s(i) {
    return a(this.__data__, i) > -1;
  }
  return r = s, r;
}
export {
  u as __require
};
